export default __webpack_public_path__ + "static/cloudator-2-thumb-6fb170ba8e1af3f959a628a023e9ff2f.png";